export const topics = [
  {
    id: "variety-stage-rule-change",
    title: "《披荆斩棘的舞台3》赛制改动，评分一路走高",
    category: "variety",
    tags: ["赛制", "舞台", "打分"],
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20toned%20editorial%20illustration%20of%20a%20glowing%20variety%20show%20stage%20with%20abstract%20spotlight%20beams%20and%20distant%20empty%20seat%20rows%2C%20soft%20studio%20lighting%2C%20textured%20cream%20background%2C%20minimal%20composition%2C%20cinematic%20warm%20orange%20and%20amber%20palette&width=800&height=600&seq=bl91-topic-variety-stage&orientation=landscape",
    author: "瓜田观察员",
    date: "2026-09-08",
    readTime: "6 分钟",
    views: 128400,
    commentCount: 3421,
    heat: 97,
    summary:
      "本季把大众评审席位从固定人数改成流动打分，节目刚播出两期，评分曲线就出现了明显上扬。评论区讨论的焦点从「谁被淘汰」转向了「赛制到底公不公平」。",
    sections: [
      {
        heading: "赛制具体改了什么",
        paragraphs: [
          "和上一季相比，最大的变化是打分权被拆成了三部分：现场大众评审占五成、专业评审占三成、线上限时投票占两成。制作方在节目花絮里解释，这样调整是为了避免单一评审团的口味主导结果。",
          "另一个细节是「流动席位」——每轮都会随机替换一部分现场评审，官方称这是为了减少固定观众对选手的熟悉度偏好。",
        ],
      },
      {
        heading: "网友为什么争论",
        paragraphs: [
          "支持的一方认为，拆分打分权让结果更接近真实人气，前两期排名也确实更接近社交平台的热度走势。",
          "质疑的一方则担心，线上限时投票容易被集中组织，反而放大了有组织投票的影响。两派在评论区各执一词，但都认可这次改动让节目更有讨论度。",
        ],
      },
    ],
    quote: "赛制公不公平，最终要靠作品说话，观众其实比想象中更看过程。",
  },
  {
    id: "drama-long-street-lights-ending",
    title: "都市剧《长街灯火》大结局，评论区吵翻了",
    category: "drama",
    tags: ["结局", "口碑", "角色"],
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20toned%20editorial%20illustration%20of%20a%20quiet%20city%20street%20at%20dusk%20with%20glowing%20shop%20windows%20and%20long%20shadows%2C%20soft%20film%20grain%2C%20creamy%20warm%20background%2C%20minimal%20cinematic%20composition%2C%20amber%20and%20coral%20palette&width=800&height=600&seq=bl91-topic-drama-street&orientation=landscape",
    author: "追剧不熬夜",
    date: "2026-09-07",
    readTime: "7 分钟",
    views: 205600,
    commentCount: 5812,
    heat: 99,
    summary:
      "一部原本走温和路线的都市剧，因为最后一集的时间线处理，让观众的解读分裂成两派。有人说这叫留白，有人说这是没讲完。",
    sections: [
      {
        heading: "结局里被反复截取的镜头",
        paragraphs: [
          "最后一集用一段长镜头收尾，主角在旧街口站了很久，画外音只保留了环境声。这个处理被观众截了无数次，成为争议的起点。",
          "支持者认为这是克制的表达，把人物的犹豫交给了观众去体会；反对者觉得关键转折没有交代，情绪落点来得太突然。",
        ],
      },
      {
        heading: "两种解读背后的期待差异",
        paragraphs: [
          "讨论中逐渐清晰的是：习惯留白叙事的观众更买账，而追剧时更关注剧情闭环的观众较难接受。分歧其实来自对「讲清楚」的不同定义。",
          "剧集官方并未给出统一解释，这也让评论区形成了更加自发、也更激烈的观点交锋。",
        ],
      },
    ],
    quote: "争议本身就是这部剧最大的话题度，吵着吵着，大家又把细节重看了一遍。",
  },
  {
    id: "music-festival-venue-change",
    title: "星潮音乐节临时换场，观众现场反应两极",
    category: "music",
    tags: ["音乐节", "现场", "退票"],
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20toned%20editorial%20illustration%20of%20an%20outdoor%20music%20festival%20crowd%20silhouette%20at%20sunset%20with%20abstract%20stage%20lights%2C%20soft%20dusty%20atmosphere%2C%20creamy%20warm%20background%2C%20minimal%20cinematic%20composition%2C%20amber%20and%20terracotta%20palette&width=800&height=600&seq=bl91-topic-music-festival&orientation=landscape",
    author: "巡演打卡人",
    date: "2026-09-06",
    readTime: "5 分钟",
    views: 98200,
    commentCount: 2760,
    heat: 93,
    summary:
      "由于场地临时调整，音乐节从原定的滨江草坪挪到了室内场馆。退票方案公布后，观众的反应出现了明显的两极分化。",
    sections: [
      {
        heading: "临时调整是怎么发生的",
        paragraphs: [
          "主办方在演出前一天发布公告，解释因天气预警和场地安全评估，决定把演出移入室内。公告同时开放了全额退票通道。",
          "对已经到场的外地观众来说，室内场馆的交通反而更方便，但也有人质疑室内场地能否承载原本期待的露天氛围。",
        ],
      },
      {
        heading: "退票方案引出的话题",
        paragraphs: [
          "退票方案里对交通成本的补偿没有明确说明，这成为评论区争议最多的一点。有观众晒出改签记录，表示希望主办方给出统一标准。",
          "也有不少人选择继续观演，认为临时调整是安全优先，现场实际体验并不差。两种声音在同一话题下持续更新。",
        ],
      },
    ],
    quote: "安全优先没有争议，但善后细节能不能讲清楚，决定了口碑走向。",
  },
  {
    id: "creator-mountain-food-return",
    title: "博主「山野食记」停更三个月后回归",
    category: "creator",
    tags: ["创作者", "回归", "内容"],
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20toned%20editorial%20illustration%20of%20a%20rustic%20outdoor%20cooking%20scene%20with%20a%20steaming%20pot%20and%20wooden%20table%2C%20soft%20morning%20light%2C%20creamy%20warm%20background%2C%20minimal%20composition%2C%20amber%20and%20olive%20palette&width=800&height=600&seq=bl91-topic-creator-mountain&orientation=landscape",
    author: "内容补给站",
    date: "2026-09-05",
    readTime: "4 分钟",
    views: 76400,
    commentCount: 1890,
    heat: 88,
    summary:
      "以乡村美食记录为主的创作者「山野食记」在停更三个月后发布新一期内容，回归方式本身成了网友讨论的重点。",
    sections: [
      {
        heading: "回归的第一期讲了什么",
        paragraphs: [
          "新一期没有做预告，直接以一段安静的备菜画面开场，字幕只简单交代了停更原因与接下来的更新节奏。",
          "相比以往追求画面精致的风格，这期内容明显更朴素，镜头停留时间更长，配乐也压得很低。",
        ],
      },
      {
        heading: "网友讨论的方向",
        paragraphs: [
          "一部分观众欣赏这种不做解释的回归，认为把注意力还给内容本身很克制；另一部分观众则希望创作者能更清楚地说明停更原因。",
          "讨论最终落回一个老话题：创作者与观众之间，到底需要多少「交代」。",
        ],
      },
    ],
    quote: "回归方式本身就是内容的一部分，观众其实在意的不是解释，而是真诚。",
  },
  {
    id: "backstage-costume-reveal",
    title: "某剧组路透流出，服化道成讨论焦点",
    category: "backstage",
    tags: ["路透", "服化道", "制作"],
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20toned%20editorial%20illustration%20of%20historic%20costume%20fabric%20detail%20on%20a%20mannequin%20in%20a%20quiet%20studio%2C%20soft%20window%20light%2C%20creamy%20warm%20background%2C%20minimal%20composition%2C%20amber%20and%20muted%20red%20palette&width=800&height=600&seq=bl91-topic-backstage-costume&orientation=landscape",
    author: "幕后放大镜",
    date: "2026-09-04",
    readTime: "5 分钟",
    views: 89300,
    commentCount: 2140,
    heat: 90,
    summary:
      "一组拍摄现场的路透图在网络流传，讨论很快从演员本身转移到了服装与场景的还原度上，制作细节成了新的关注点。",
    sections: [
      {
        heading: "路透里被放大的细节",
        paragraphs: [
          "网友把图片中的冠饰、纹样和材质逐一比对，指出其中几处与设定的年代不符，也有考据爱好者给出了相反的依据。",
          "这类讨论往往缺乏完整语境，但参与度很高，很多人是把它当成一次普及服饰知识的契机。",
        ],
      },
      {
        heading: "理性看待路透的方式",
        paragraphs: [
          "剧组尚未回应，路透本身也可能只是试装或临时造型，因此把单张图片当成最终成片来判断并不严谨。",
          "比较被认可的态度是：把讨论限定在公开可见的细节上，等正片播出后再做整体评价。",
        ],
      },
    ],
    quote: "考据是好事，但路透不等于成片，多一点耐心往往能看到更完整的答案。",
  },
  {
    id: "variety-guest-wishlist",
    title: "综艺嘉宾阵容猜测，网友列出心愿名单",
    category: "variety",
    tags: ["嘉宾", "阵容", "讨论"],
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20toned%20editorial%20illustration%20of%20an%20empty%20television%20studio%20set%20with%20warm%20panel%20lights%20and%20round%20host%20table%2C%20soft%20studio%20glow%2C%20creamy%20warm%20background%2C%20minimal%20composition%2C%20amber%20and%20coral%20palette&width=800&height=600&seq=bl91-topic-variety-studio&orientation=landscape",
    author: "综艺前瞻社",
    date: "2026-09-03",
    readTime: "4 分钟",
    views: 64100,
    commentCount: 1520,
    heat: 85,
    summary:
      "新一季节目尚未官宣，网络上已经出现了各种版本的嘉宾名单。比起真假，网友更享受的是聚在一起讨论「希望谁来」。",
    sections: [
      {
        heading: "猜测从哪来",
        paragraphs: [
          "一些讨论源自录制基地周边的路透，另一些则来自节目组公开招募观众的公告，信息零散但足够引发联想。",
          "由于官方迟迟未公布，评论区逐渐变成了一个自发的「心愿名单」收集地，热闹程度甚至超过了正式的节目讨论。",
        ],
      },
      {
        heading: "讨论里的分寸感",
        paragraphs: [
          "在众多猜测中，也有网友提醒不要把未经证实的名单当成既定事实，避免给嘉宾带来不必要的关注压力。",
          "多数参与者更愿意把它当作一次轻松的闲聊，而非对节目组的施压。",
        ],
      },
    ],
    quote: "猜阵容的乐趣在于参与感，别把玩笑变成压力，热热闹闹就好。",
  },
  {
    id: "music-band-tour-tickets",
    title: "老牌乐队巡演门票秒空，二手价格引争议",
    category: "music",
    tags: ["巡演", "门票", "乐迷"],
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20toned%20editorial%20illustration%20of%20a%20concert%20hall%20stage%20with%20a%20drum%20kit%20and%20guitar%20silhouette%20under%20warm%20spotlights%2C%20soft%20haze%2C%20creamy%20warm%20background%2C%20minimal%20composition%2C%20amber%20and%20terracotta%20palette&width=800&height=600&seq=bl91-topic-music-tour&orientation=landscape",
    author: "乐迷电台",
    date: "2026-09-02",
    readTime: "5 分钟",
    views: 112700,
    commentCount: 3305,
    heat: 95,
    summary:
      "一支老牌乐队的巡演门票在开售数分钟内售罄，随后二手平台出现明显加价，围绕票务的话题再一次被推上台面。",
    sections: [
      {
        heading: "抢票现场的实际情况",
        paragraphs: [
          "多位乐迷表示，开售瞬间系统就显示排队，真正进入选座页面时已所剩无几。也有幸运者晒出了原价票的订单截图。",
          "演唱会门票的分配一直存在争议，实名制购票、限购数量等规则在不同场次执行力度并不一致。",
        ],
      },
      {
        heading: "乐迷的两种态度",
        paragraphs: [
          "一部分乐迷主张坚决抵制加价票，宁可不看也不助长；另一部分则因为行程已定，选择在可接受范围内购票。",
          "讨论中更高频的诉求，其实是希望官方能增加场次或采用更透明的方式分配座位。",
        ],
      },
    ],
    quote: "与其互相指责，不如一起把「更多场次、更透明分配」的声音传出去。",
  },
  {
    id: "drama-yearly-rating-board",
    title: "年度剧集口碑榜出炉，评分差异为何这么大",
    category: "drama",
    tags: ["榜单", "评分", "口碑"],
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20toned%20editorial%20illustration%20of%20stacked%20film%20reels%20and%20a%20clapperboard%20on%20a%20warm%20wooden%20table%2C%20soft%20directional%20light%2C%20creamy%20warm%20background%2C%20minimal%20composition%2C%20amber%20and%20deep%20red%20palette&width=800&height=600&seq=bl91-topic-drama-rating&orientation=landscape",
    author: "剧集观察组",
    date: "2026-09-01",
    readTime: "6 分钟",
    views: 143900,
    commentCount: 4180,
    heat: 96,
    summary:
      "一份年度剧集口碑榜发布后，观众发现自己在追的剧集排名相差很大。榜单的统计口径，比排名本身引发了更多讨论。",
    sections: [
      {
        heading: "榜单是怎么来的",
        paragraphs: [
          "榜单综合了多个平台的评分、讨论量与完播率，并做了加权处理。制作方在说明中强调，权重会根据题材类型进行调整。",
          "正是这套加权方式，让一些评分相近的剧集拉开了明显差距，也让观众对「口碑」的定义产生了分歧。",
        ],
      },
      {
        heading: "讨论最有价值的部分",
        paragraphs: [
          "讨论并没有停留在「谁高谁低」，而是延伸到了评分机制本身的合理性：讨论量高的剧是否就一定更优秀。",
          "一些观众开始主动分享自己心中的排名，让榜单变成了一个观察大众审美的窗口。",
        ],
      },
    ],
    quote: "榜单只是参考，真正决定一部剧口碑的，还是它能不能被反复提起。",
  },
  {
    id: "industry-actor-behind-camera",
    title: "演员转型幕后，新项目立项消息引关注",
    category: "industry",
    tags: ["转型", "制作", "立项"],
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20toned%20editorial%20illustration%20of%20a%20quiet%20production%20meeting%20table%20with%20scripts%20and%20a%20storyboard%20sketch%2C%20soft%20afternoon%20light%2C%20creamy%20warm%20background%2C%20minimal%20composition%2C%20amber%20and%20warm%20brown%20palette&width=800&height=600&seq=bl91-topic-industry-studio&orientation=landscape",
    author: "行业茶水间",
    date: "2026-08-30",
    readTime: "5 分钟",
    views: 58700,
    commentCount: 1240,
    heat: 82,
    summary:
      "一位以表演被记住的演员，近两年逐渐把重心转向制作端。新项目立项的消息传出后，讨论集中在转型本身是否可行。",
    sections: [
      {
        heading: "转型的信号",
        paragraphs: [
          "过去两年，这位演员参与的多是监制或联合出品的工作，公开露面的身份也在慢慢变化。新项目立项的信息来自公开备案，细节仍有限。",
          "从业者认为，演员转向幕后并不罕见，关键在于是否能建立起稳定的制作团队。",
        ],
      },
      {
        heading: "网友关注的角度",
        paragraphs: [
          "讨论里既有期待，也有观望。期待的一方希望新的视角能带来不一样的题材；观望的一方则担心资源与经验的积累是否足够。",
          "整体来看，讨论比以往同类话题更冷静，更多人愿意等项目真正落地后再评价。",
        ],
      },
    ],
    quote: "转型不是换个位置，而是换一种方式讲故事，成片才是最终答案。",
  },
];